import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Testimonial from './components/Testimonial';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import CommunityMap from './components/CommunityMap';
import SearchSection from './components/SearchSection';
import PromoBanner from './components/PromoBanner';
import Donation from './components/Donation';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Stats />
      <SearchSection />
      <PromoBanner />
      <HowItWorks />
      <Features />
      <Gallery />
      <CommunityMap />
      <Testimonial />
      <Pricing />
      <FAQ />
      <Donation />
      <CTA />
      <Footer />
    </div>
  );
}
